<template>
  <el-row>
    <el-col :span="24">
      <el-card class="box-card">
        <div slot="header" class="clearfix flex justify-between">
          <span>员工信息</span>
          <el-button 
            type="primary" 
            size="small" 
            style="float: right; margin-left: 10px;"
            @click="_openSelectStaffInfoModel"
          >
            <i class="el-icon-search"></i> 选择
          </el-button>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="form-item">
              <label class="form-label">员工ID：</label>
              <span class="form-value">{{viewStaffInfo.userId}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="form-item">
              <label class="form-label">员工名称：</label>
              <span class="form-value">{{viewStaffInfo.name}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="form-item">
              <label class="form-label">员工邮箱：</label>
              <span class="form-value">{{viewStaffInfo.email}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="form-item">
              <label class="form-label">手机号：</label>
              <span class="form-value">{{viewStaffInfo.tel}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="form-item">
              <label class="form-label">员工性别：</label>
              <span class="form-value">{{viewStaffInfo.sex === '0' ? '男' : '女'}}</span>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
    <search-staff 
      ref="searchStaff"
      :call-back-listener="'viewStaffInfo'"
      :call-back-function="'chooseStaff'"
    ></search-staff>
  </el-row>
</template>

<script>
import SearchStaff from '@/components/frame/searchStaff/searchStaff.vue'

export default {
  name: 'ViewStaffInfo',
  components: {
    SearchStaff
  },
  props: {
    callBackListener: {
      type: String,
      default: ''
    },
    callBackFunction: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      viewStaffInfo: {
        index: 0,
        flowComponent: 'viewStaffInfo',
        userId: '',
        name: '',
        email: '',
        tel: '',
        sex: '',
        orgId: ''
      }
    }
  },
  methods: {
    initInfo(info) {
      this.viewStaffInfo = {...this.viewStaffInfo, ...info}
    },
    clear() {
      this.viewStaffInfo = {
        index: 0,
        flowComponent: 'viewStaffInfo',
        userId: '',
        name: '',
        email: '',
        tel: '',
        sex: '',
        orgId: ''
      }
    },
    _openSelectStaffInfoModel() {
      this.$refs.searchStaff.open({
        orgId: this.viewStaffInfo.orgId
      })
    }
  }
}
</script>

<style scoped>
.form-item {
  margin-bottom: 18px;
}
.form-label {
  font-weight: bold;
  margin-right: 10px;
}
.form-value {
  color: #606266;
}
</style>